function inputSeriesData(currSeries, data) {
    const newSeries = currSeries.map(serie =>
        serie.id === data.id
            ? { ...serie, ...data } // criado um novo objeto sem mutar o original
            : serie
    );

    // Se não encontrou a série, adiciona uma nova entrada
    const foundSerie = newSeries.some(serie => serie.id === data.id);
    return foundSerie ? newSeries : [...newSeries, data];
}

export default (state = [], action) => {
    switch (action.type) {
        case 'INPUT_SERIES_DATA':
            return inputSeriesData(state, action.payload);
        default:
            return state;
    }
}